// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__139ya","loaderOuter":"PageOverlayLoader_loaderOuter__11QN7"};